import kion from 'assets/images/aboutUsPage/materials/kion.png'
import kion_mts from 'assets/images/aboutUsPage/materials/kion_created_by_mts.png'
import zipIcon from 'assets/icons/zip-icon.svg'
import pdfIcon from 'assets/icons/pdf-icon-44.svg'

export type ZipType = {
  name: string
  href: string
  preview?: string
  previewMobile?: string
  previewAlt?: string
  fileIcon: string
}

export type MaterialType = {
  title: string
  descr?: string
  zips: ZipType[]
  withPreview?: boolean
}

export const Materials: MaterialType[] = [
  {
    title: 'Руководство по использованию фирменного стиля (гайдбук)',
    zips: [
      {
        name: 'Руководство по использованию фирменного стиля (гайдбук)',
        href: 'Rukovodstvo_po_ispolzovaniyu_firmennogo_stilya_(gajdbuk).pdf',
        fileIcon: pdfIcon,
      },
    ],
  },
  {
    title: 'Логотипы',
    withPreview: true,
    zips: [
      // {
      //   name: 'MTS_Media_rus (98 MB)',
      //   href: 'MTS_Media_rus.zip',
      //   preview: mtsmedia_ru,
      //   previewAlt: 'mtsMedia',
      //   fileIcon: zipIcon,
      // },
      // {
      //   name: 'MTS_Media_eng (98 MB)',
      //   href: 'MTS_Media_eng.zip',
      //   preview: mtsmedia_en,
      //   previewAlt: 'mtsMedia',
      //   fileIcon: zipIcon,
      // },
      {
        name: 'KION_logo (2 MB)',
        href: 'KION_logo.zip',
        preview: kion,
        previewAlt: 'kion',
        fileIcon: zipIcon,
      },
      {
        name: 'KION_logo_full (2 MB)',
        href: 'KION_logo_full.zip',
        preview: kion_mts,
        previewAlt: 'kion',
        fileIcon: zipIcon,
      },
    ],
  },
]
